import React from 'react';
import "../../styles/vote/cast_vote.css";

import { useEffect, useState } from "react";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, getDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

import ActiveVoteIcon from "../../images/vote/active_cast_vote_icon_b.png";
import InactiveVoteIcon from "../../images/vote/inactive_cast_vote_icon.png";

const CastVote = ({getShow, setShow, getItemId, getItemName, getItemGenre, getSingleGenre, getItemType}) => {
    const [getUserId, setUserId] = useState("");
    const [getMajorList] = useState([
        "Action", "Thriller", "Mystery", "Comedy", "Horror", "Family", "Animation", 
        "Adventure", "Drama", "Romance", "Science Fiction", "News", "Kids",
        "Reality", "Soap", "Talk", "Western", "War", "Documentary",
        "History", "Fantasy", "Crime", "Music",
    ]);
    const [getGenreList, setGenreList] = useState([]);
    const [getUpdatedGenreList, setUpdatedGenreList] = useState([]);
    const [getVoteList, setVoteList] = useState([]);

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.toLocaleDateString('en-US', {
        month: 'long',
    });
    const date = `${currentMonth.toLowerCase()}_${currentYear}`;
    
    const onDone = () => {
        setShow(false);
    };

    const onVoteGenre = async (name) => {
        try {
            const itemRef = doc(firebaseFirestore, 'User Votes', date); 
            const itemDoc = await getDoc(itemRef);
            if (itemDoc.exists()) {
                let exists = false;
                const itemData = itemDoc.data();
                Object.keys(itemData).forEach(async (fieldName) => {
                    if (fieldName === getUserId) {
                        const field = itemData[fieldName];
                        Object.entries(field).forEach(async ([key, value]) => {
                            if (key === `${name.toLowerCase()}_${getItemType.toLowerCase()}`) {
                                exists = true;
                                let map = {};
                                map = field;
                                delete map[key];
                                if (value === `${getItemType}_${getItemId}`) {
                                    await updateDoc(itemRef, {[`${getUserId}`]: map});
                                }else{
                                    await updateDoc(itemRef, { [`${getUserId}.${name.toLowerCase()}_${getItemType.toLowerCase()}`]: `${getItemType.toLowerCase()}_${getItemId.toLowerCase()}` }, { merge: true });
                                }
                            }
                        })
                    }
                })

                if (exists === false) {
                    await updateDoc(itemRef, { [`${getUserId}.${name.toLowerCase()}_${getItemType.toLowerCase()}`]: `${getItemType.toLowerCase()}_${getItemId.toLowerCase()}` }, { merge: true });
                }
            }else{
                await setDoc(itemRef, { [`${getUserId}.${name.toLowerCase()}_${getItemType.toLowerCase()}`]: `${getItemType.toLowerCase()}_${getItemId.toLowerCase()}` }, { merge: true });
            }
        } catch (error) {
            console.log(error.message);
        };
    };

    const getVoteItems = async () => {
        try {
            const itemRef = doc(firebaseFirestore, 'User Votes', date);
            const scription = onSnapshot(itemRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const itemData = docSnapshot.data();
                    let itemArray = [];
                    Object.keys(itemData).forEach((fieldName) => {
                        if (fieldName == getUserId) {
                            const data = itemData[fieldName];
                            Object.keys(data).forEach((item) => {
                                if (data[item] == `${getItemType}_${getItemId}`) {
                                    itemArray.push(item.split("_")[0]);
                                }
                            })
                        }
                    });

                    const sortedItems = itemArray.sort((a, b) => {
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        }
                        return 0;
                    });

                    setVoteList(sortedItems);
                }
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        }
    };

    const UpdateGenreList = () => {
        getGenreList.map((items) => {
            if (items.includes("&")) {
                items.split(" & ").map((item) => {
                    if (item === "Sci-Fi") {
                        getUpdatedGenreList.push("Science Fiction");
                    } else {
                        getUpdatedGenreList.push(item);
                    }
                })
            } else {
                getUpdatedGenreList.push(items);    
            }
        })
    }

    useEffect(() => {
        UpdateGenreList();
    }, [getGenreList]);

    useEffect(() => {
        getVoteItems();
    }, [getUserId, getVoteItems]);

    useEffect(() => {
        setGenreList(getItemGenre.split(", "));
    }, [getItemGenre]);

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            }
        });
    }, []);

    return(
        <div className={`cast_vote_dialog ${getShow ? "show" : ""}`}>
            <p className="cast_vote_dialog_header">Vote</p>
            <p className="cast_vote_dialog_header_sub">{getGenreList.length > 0 ? `Nominate "${getItemName}" for the best:` : `Voting for "${getItemName}" is unavailable at the moment. Try again later 😊`}</p>
            <div className="cast_vote_dialog_content">
                {
                    getGenreList.length > 0
                    ? getUpdatedGenreList.map((items, index) => (
                        getMajorList.includes(items)
                        ? <div key={index} className="cast_vote_dialog_row" >
                            <div className="cast_vote_dialog_column">
                                <p className="cast_vote_dialog_column_head">{items}</p>
                                <p className="cast_vote_dialog_column_sub">{getItemType === "movie" ? "Movie" : "Tv series"}</p>
                            </div>
                            <img alt="vote" onClick={() => onVoteGenre(items)} className="cast_vote_dialog_row_image" src={getVoteList.includes(items.toLowerCase()) ? ActiveVoteIcon : InactiveVoteIcon} />
                        </div>
                        : null
                    ))
                    : null
                }
            </div>
            <div className="add_item_to_collections_done" onClick={() => onDone()}>{getGenreList.length > 0 ? "Done" : "Close"}</div>
        </div>
    );
};

export default CastVote;